import React from "react";
import { AppBar, Link, Logout } from "react-admin";
import { Typography, IconButton, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { settings } from "../../app";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import ProfileName from "./ProfileName";

const CustomAppBar = props => {
  return (
    <AppBar
      {...props}
      userMenu={
        <>
          {settings?.ProfileMenu ? <settings.ProfileMenu /> : <ProfileName />}
          <Box sx={settings.logoutstyle || null}>
            <Logout icon={<MeetingRoomIcon />} />
          </Box>
        </>
      }
    >
      <IconButton
        size="large"
        onClick={() => {
          window.location = settings.homeIconUrl ? settings.homeIconUrl : "/";
        }}
        style={settings.homeIconStyle || null}
      >
        <HomeIcon />
      </IconButton>
      <Typography
        style={{ flex: 1 }}
        id="react-admin-title"
      />
      {settings?.logo && (
        <div style={{ display: "flex", flex: 1 }}>
          <Link
            to={settings.logoUrl || "/"}
            sx={{ width: "min-content" }}
          >
            <img
              src={settings.logo}
              alt="logo"
            />
          </Link>
        </div>
      )}

      {settings?.LocaleButton && <settings.LocaleButton />}
    </AppBar>
  );
};

export default CustomAppBar;
